// src/components/ParliamentCards.js
import React, { useState } from "react";
import "../../styles/info/ParliamentCards.css";
import houseImg from "../../assets/backgroundinfo_house_of_representatives.png";
import senateImg from "../../assets/backgroundinfo_house_of_representatives.png";
import goverImg from "../../assets/backgroundinfo_house_of_representatives.png";

// const cardData = [
//   {
//     title: "House Of Representatives",
//     subtitle: "Laws Proposed",
//     image: houseImg,
//   },
//   {
//     title: "Senate",
//     subtitle: "Review And Check The Law",
//     image: senateImg,
//   },
//   {
//     title: "Governor General",
//     subtitle: "Final Approval",
//     image: goverImg,
//   },
// ];

// const ParliamentCards = () => {
//   return (
//     <div className="parliament-card-wrapper">
//       {cardData.map((card, index) => (
//         <div className="parliament-card" key={index}>
//           <h3>{card.title}</h3>
//           <p className="subtitle">{card.subtitle}</p>
//           <img src={card.image} alt={card.title} />
//         </div>
//       ))}
//     </div>
//   );
// };

const cardData = [
  {
    title: "House Of Representatives",
    subtitle: "Laws Proposed",
    image: houseImg,
    facts: [
      "Members Elected Via Preferential Voting",
      "Majority Party Forms Government",
      "PM And Ministers Come From This House",
      "Debates And Introduces Most New Laws",
    ],
  },
  {
    title: "Senate",
    subtitle: "Review And Check The Law",
    image: senateImg,
    facts: [
      "76 Senators (12/State, 2/Territory)",
      "6-Year Terms (3 For Territories)",
      "Elected Via Proportional Voting",
      "Reviews And Approves House Bills",
    ],
  },
  {
    title: "Governor General",
    subtitle: "Final Approval",
    image: goverImg,
    facts: [
      "Represents The Monarch As Head Of State",
      "Appointed On PM’s Advice",
      "Gives Royal Approval To Laws",
      "Can Dissolve Parliament And Call Elections",
    ],
  },
];

const ParliamentCards = () => {
  const [flippedIndex, setFlippedIndex] = useState(null);

  const handleFlip = (index) => {
    setFlippedIndex(flippedIndex === index ? null : index);
  };

  return (
    <div className="parliament-card-wrapper">
      {cardData.map((card, index) => (
        <div
          className={`parliament-card ${
            flippedIndex === index ? "flipped" : ""
          }`}
          key={index}
          onClick={() => handleFlip(index)}
        >
          <div className="card-inner">
            {/* Front */}
            <div className="card-front">
              <h3>{card.title}</h3>
              <p className="subtitle">{card.subtitle}</p>
              <img src={card.image} alt={card.title} />
            </div>

            {/* Back */}
            <div className="card-back">
              <h2>{card.title}</h2>
              <h3>Key Facts:</h3>
              <ul>
                {card.facts.map((fact, i) => (
                  <li key={i}>{fact}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ParliamentCards;
